import Vue from "vue";
import { mapGetters } from "vuex";
import { LoadingSpinner } from "@/components";

// Icons
import { faDownload, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Serices
import { ErrorLogService, ObjectUtil, QuickOrderService } from "@/services";

// Types
import { IQuickOrdersContext } from "../../QuickOrders.types";

import { DownloadJsonToCsv } from "@/components/Elements/DownloadJsonToCsv";

export default Vue.extend({
  name: "UploadFileTab",
  components: {
    FontAwesomeIcon,
    LoadingSpinner,
    DownloadJsonToCsv
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
    isSubmitDisabled() {
      return this.selectedFiles === null || this.selectedFiles.length === 0;
    },
    isTextAreaEmpty() {
      var disabled = true;
      if(this.textAreaCsvInput != "") {
        disabled = false;
      }
      return disabled;
    },
    quickOrderUploadTemplateForDownload(){
      return [{        
        "PartCode": "",
        "Quantity": "",
        "StockingLocation (optional)": "",
        "DealerSku (optional)": ""
      }]    
    }   
  },
  data: () => ({
    fileFormat: "csv",
    fileFormats: [],
    downloadIcon: faDownload,
    openFolderIcon: faFolderOpen,
    selectedFiles: null,
    errorMessage: null,
    isUploading: false,
    textAreaCsvInput: "",
  }),
  mounted() {
    this.fileFormats = [
      { text: this.getContentItem("CSV"), value: "csv" },
      { text: this.getContentItem("ANTARES"), value: "antares" },
    ];
  },
  methods: {
    fileChanged(e: Event) {
      const fileInput = e.target as any;

      const files = Array.from(fileInput.files) as File[];

      this.selectedFiles = files.map((f) => f.name);
    },

    async submitForm() {
      try {
        this.isUploading = true;
        this.errorMessage = "";

        this.textAreaCsvInput = this.sanitizeQuantityInput();

        const ctx = this.context as IQuickOrdersContext;

        var files = new Array();

        if(this.textAreaCsvInput != "") {
          files.push(new File([this.textAreaCsvInput], "quickOrder-paste.csv", {type: "text/plain"}));
        } else {
          files = this.getFiles();
        }

        const input = {
          accountId: ctx.accountId,
          userId: ctx.user.UserId,
          userAudiences: ctx.userAudiences,
          partListId: ctx.partListId,
          fileType: this.fileFormat,
          files: files,
        };

        const response = await QuickOrderService.uploadFile(input);
        
        if (response.errorMessage) {
          this.errorMessage = response.errorMessage;
 
          this.$store.commit("pushMessage", {
            header: "File upload error: " + this.errorMessage,
            IsError: true
          });  
 

        } else {
          this.$store.commit("pushTimedMessage", {
            header: "File upload complete",
            IsError: false,
            seconds: 5,
          });  
        }


        this.$emit("file-uploaded", response);
      } catch (ex) {
        this.errorMessage = ErrorLogService.LogAndGetErrorMessage(ex);
      } finally {
        this.isUploading = false;

        this.resetFiles();
      }
    },

    sanitizeQuantityInput(){

      this.textAreaCsvInput = this.textAreaCsvInput.trim();
      if(this.textAreaCsvInput == ""){
        return "";
      }
      // Protect the user against accidental spaces after comma delimiter
      this.textAreaCsvInput = this.textAreaCsvInput.replaceAll(", ", ",");

      // If a user enters a part number with no quantity, add quantity of 1.
      let lineSplitInput = this.textAreaCsvInput.split(/\r?\n/);

        let newCsvInput = ""
        for(let i = 0; i < lineSplitInput.length; i++){
          let lineInput = lineSplitInput[i]
          
          // add a quantity of 1 if there isn't one
          if( this.fileFormat === "csv" && !lineInput.includes(",")){
            lineInput += ",1"
            newCsvInput += lineInput + "\r\n"
          }else{
            newCsvInput += lineInput + "\r\n"
          }
        }

        return newCsvInput === "" ? this.textAreaCsvInput : newCsvInput;
    },

    DragAndDropIsSupported() {
      return !(window as any).IsIE();
    },

    getFiles() {
      return Array.from(this.getFileInput().files) as File[];
    },

    getFileInput() {
      return this.$refs["file-input"];
    },

    resetFiles() {
      this.selectedFiles = null;

      const input = this.getFileInput();

      // HACK: cross-browser hack, not all browsers allow setting the value of a file input to null, but temporarily switching input type does work universally.
      try {
        input.type = null;
        input.value = null;
      } finally {
        input.type = "file";
      }
    },

    showFileDialog() {
      this.getFileInput().click();
    },
  },
});
